import React, { useState } from 'react';

// Components
import { WpButton, WpButtonDropdown } from '..';
import WpIcon from '../../icon/WpIcon';
import { WpDropdownMenu, WpDropdownMenuItem } from '../../dropdown';

const ButtonsDocs = () => {
  const [loadingExample, toggleLoading] = useState(false);
  const sizes = ['xs', 'sm', 'md', 'lg'] as const;
  const variants = ['primary', 'secondary', 'tertiary', 'link'] as const;
  const colors = ['primary', 'danger', 'white', 'gray'] as const;

  const loadingExampleClick = () => {
    toggleLoading(state => !state);

    setTimeout(() => {
      toggleLoading(state => !state);
    }, 2000);
  };

  return (
    <>
      <h5>sizes</h5>
      <div className="d-flex align-items-center">
        {sizes.map(size => {
          return (
            <div className="mr-4">
              <WpButton key={size} size={size}>
                Size: {size}
              </WpButton>
            </div>
          );
        })}
      </div>
      <h5 className="mt-5">Color / Variants</h5>
      {colors.map(color => {
        const bgColor = color === 'white' ? 'gray' : 'white';
        return (
          <div className="py-2" style={{ backgroundColor: bgColor }}>
            {color}
            {variants.map(variant => (
              <span className="mx-4">
                <WpButton key={`${variant}-${color}`} variant={variant} color={color}>
                  {' '}
                  {variant}
                </WpButton>
              </span>
            ))}
          </div>
        );
      })}
      <h5 className="mt-5">with icons</h5>
      <div className="d-flex align-items-center">
        {sizes.map(size => {
          return (
            <div className="mr-4">
              <WpButton key={size} size={size}>
                <WpIcon name="plus-circle" />
                Size: {size}
              </WpButton>
            </div>
          );
        })}
      </div>
      <div className="d-flex align-items-center">
        {sizes.map(size => {
          return (
            <div className="mt-4 mr-4">
              <WpButton key={size} size={size} variant="secondary" loading>
                Size: {size}
                <WpIcon name="plus-circle" />
              </WpButton>
            </div>
          );
        })}
      </div>

      <h5 className="mt-5">icons only</h5>
      <div className="d-flex align-items-center">
        {sizes.map(size => {
          return (
            <div className="mr-4">
              <WpButton key={size} size={size} variant="secondary">
                <WpIcon name="ellipsis-h-alt" />
              </WpButton>
            </div>
          );
        })}
      </div>

      <h5 className="mt-5">Disabled</h5>
      {colors.map(color => {
        return (
          <div className="mb-2">
            {color}
            {variants.map(variant => (
              <span className="mr-4">
                <WpButton key={`${variant}-${color}`} variant={variant} color={color} disabled>
                  {' '}
                  {variant}
                </WpButton>
              </span>
            ))}
          </div>
        );
      })}
      <h5 className="mt-5">Block</h5>
      {sizes.map(size => {
        return (
          <div className="mb-2">
            <WpButton size={size} block>
              Size: {size}
            </WpButton>
          </div>
        );
      })}

      <h5 className="mt-5">Loading</h5>
      <WpButton onClick={loadingExampleClick} loading={loadingExample}>
        Click Me
      </WpButton>

      <div className="mt-3">
        {colors.map(color => {
          return (
            <div className="mb-2">
              {color}
              {variants.map(variant => (
                <span className="mr-4">
                  <WpButton key={`${variant}-${color}`} variant={variant} color={color} loading>
                    {' '}
                    {variant}
                  </WpButton>
                </span>
              ))}
            </div>
          );
        })}
      </div>

      <h5 className="mt-5">BUTTON SPLIT DROPDOWN</h5>
      {colors.map(color => {
        const bgColor = color === 'white' ? 'gray' : 'white';
        return (
          <div className="d-flex py-2" style={{ backgroundColor: bgColor }}>
            {color}
            {variants.map(variant => (
              <span className="mx-4">
                <WpButtonDropdown
                  key={`${variant}-${color}`}
                  color={color}
                  variant={variant}
                  onClick={() => alert('clicked button')}
                  addOnDropdownMenu={
                    <WpDropdownMenu>
                      <WpDropdownMenuItem onClick={() => alert('Item One')}>Item One</WpDropdownMenuItem>
                      <WpDropdownMenuItem onClick={() => alert('Item Two')}>Item Two</WpDropdownMenuItem>
                      <WpDropdownMenuItem onClick={() => alert('Item Three')}>Item Three</WpDropdownMenuItem>
                    </WpDropdownMenu>
                  }
                >
                  <WpIcon name="plus" />
                  Add Topic
                </WpButtonDropdown>
              </span>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default ButtonsDocs;
